import 'styles/globals.css';
import { App } from '@app/App';
import { appWithTranslation } from 'next-i18next';
import nextI18NextConfig from '../next-i18next.config';
export default appWithTranslation(App, nextI18NextConfig);